<template>
    <div class="modal fade history-filter-modal forgetwithdrawModal-cl" id="setTransactionPasswordModel" data-bs-backdrop="static" 
        data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="thm-heading">
                        <h3>Update Transaction Password</h3>
                    </div>
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetTransactionForm"></button> -->
                </div>
                <div class="modal-body">
                    <div class="withdraw-password-update">
                        <div class="withdraw-instruction">
                            <h4>{{ $t('transaction-instruction', 'Transaction Instruction') }}</h4>
                            <ul>
                                <li>{{ $t('transaction-password-eight-twenty', 'Transaction Password Must be of minimum 8 characters and maximum 20 characters required') }}</li>
                                <li>{{ $t('transaction-password-small-capital', 'Transaction Password Must have atleast 1 small and 1 capital alphabet') }}</li>
                                <li>{{ $t('transaction-password-digit-special-char', 'Transaction Password Must have atleast 1 Digit and 1 Special character') }}</li>
                                <li>{{ $t('please-take-note-your-transaction-password', 'Please take a note of your Transaction Password') }}</li>
                            </ul>
                        </div>
                       <div class="back-modal">
                            

                            <div class="number-header mb-3">
                                <label for="">{{ $t('transaction-password','Transaction Password') }}*</label>
                                <div class="password-field-rel">
                                    <input v-model="transaction.password" :type="transactionPasswordFieldType" placeholder="Enter Transaction Password" class="form-control"
                                        @input="transaction.password = $helper.sanitizeDetails('transactionPassword', transaction.password, 20); validate()" 
                                        :class="init.password && checkValidation?.transactionPassword?.length > 0 ? 'error-input' : ''" />
                                    <div class="showHide-icon" @click="togglePasswordVisibility('transactionPassword')">
                                        <i v-if="transactionPasswordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                        <i v-else aria-hidden="true" class="fa fa-eye"></i>
                                    </div>
                                </div>
                                <section v-if="init.password && checkValidation?.transactionPassword?.length > 0">
                                    <section v-for="(err, index) in checkValidation?.transactionPassword" :key="index">
                                        <p class="error-messages-text">{{ $t(err.lang, err.error) }}</p>
                                    </section>
                                </section>
                            </div>


                            <div class="number-header mb-3">
                                <label for="">Confirm Transaction Password*</label>
                                <div class="password-field-rel">
                                    <input v-model="transaction.confirmPassword" :type="confirmPasswordFieldType" placeholder="Enter Confirm Transaction Password" class="form-control"
                                        @input="transaction.confirmPassword = $helper.sanitizeDetails('transactionPassword', transaction.confirmPassword, 20); validate()" />
                                    <div class="showHide-icon" @click="togglePasswordVisibility('newPassword')">
                                        <i v-if="confirmPasswordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                        <i v-else aria-hidden="true" class="fa fa-eye"></i>
                                    </div>
                                </div>
                                <section v-if="init.c_password && checkValidation?.confirmTransactionPassword?.length > 0">
                                    <section v-for="(err, index) in checkValidation?.confirmTransactionPassword" :key="index">
                                        <p class="error-messages-text">{{ $t(err.lang, err.error) }}</p>
                                    </section>
                                </section>
                            </div>
                        </div>
                        
                        <button @click.prevent="validateTransactionPassword()" type="button" class="btn_submit_cl">{{ $t('submit','Submit') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onUpdateWithdrawTransactionPassword , validate  } from "@template/utils"
export default {
    name: 'SetTransactionPassword',
    data(){
        return{
            transaction:{
                password: null,
                confirmPassword: null,
            },
            validationErrors : null,
            transactionPasswordFieldType : 'password',
            confirmPasswordFieldType: 'password',
            init:{
                c_password:false,
                password:false
            },
        }
    },
    computed:{
        checkValidation() {
			return this.validationErrors;
		}
    },
    methods:{
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'transaction-password',
				this.transaction.password,
				this.transaction.confirmPassword,
            );
            return this.validationErrors;                                                                                                    
        },
        async resetTransactionForm(){
            this.transaction ={
                password: '',
                confirmPassword: ''
            },
            this.validationErrors = null;
            this.toggleInit(false)
        },

        toggleInit(bool){
            this.init={
                c_password:bool,
                password:bool
            }
        },
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'transactionPassword'){
                this.transactionPasswordFieldType = this.transactionPasswordFieldType === 'password' ? 'text' : 'password';
            } else{
                this.confirmPasswordFieldType = this.confirmPasswordFieldType === 'password' ? 'text' : 'password';
            }
        },
        async validateTransactionPassword() {
            this.toggleInit(true);
            if (Object.keys(this.validate())?.filter(key => ['confirmTransactionPassword', 'transactionPassword'].includes(key))?.length) return;
            const resetResponse = await this.resetTransactionPassword()
            // if transaction password reset fails, return immediately
            if (resetResponse?.error) {
                this.$errorToast(resetResponse?.error);
                return;
            }
            else{
                this.$successToast(resetResponse?.message);
                await this.resetTransactionForm();
                this.$helper.closeModal('setTransactionPasswordModel');
            }
        },
        async resetTransactionPassword(){
            if (!this.transaction.password || this.transaction.password == null) {
                this.$errorToast("New Transaction Password Required!");
                return; 
            }
            if (this.transaction.password != this.transaction.confirmPassword) {
                this.$errorToast("Confirm Transaction Password Does Not Match With New Transaction Password");
                return;
            }
           
            let response = await onUpdateWithdrawTransactionPassword(this.transaction.password);
            return response;
        },
    },
}
</script>